import { render, staticRenderFns } from "./order-status-display.vue?vue&type=template&id=830ba9e4&"
import script from "./order-status-display.vue?vue&type=script&lang=ts&"
export * from "./order-status-display.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('830ba9e4')) {
      api.createRecord('830ba9e4', component.options)
    } else {
      api.reload('830ba9e4', component.options)
    }
    module.hot.accept("./order-status-display.vue?vue&type=template&id=830ba9e4&", function () {
      api.rerender('830ba9e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/orders/components/order-status-display.vue"
export default component.exports